import { apiRequestToken } from '../Utilidades/apiRequest';
import { BannerRequest } from '../interfaces/bannerInterfaces';

export const guardarBanner = async (bannerRequest: BannerRequest) => {
    return apiRequestToken({
        endpoint: 'banner/editar',
        body: bannerRequest,
        method: 'POST',
    })
};

export const getBanners = async () => {
    return apiRequestToken({
        endpoint: 'banner/all',
        method: 'GET',
    })
};


export const getActiveBanners = async () => {
    return apiRequestToken({
        endpoint: 'banner/allActives',
        method: 'GET',
    })
};



export const getBanner = async (id:number) => {
    return apiRequestToken({
        endpoint: 'banner/' + id,
        method: 'GET',
    })
};


export const deleteBanner = async (id: number) => {
    return apiRequestToken({
        endpoint: `banner/${id}`,
        method: 'DELETE',
    })
};


export const activarDesactivarBanner = async (id: number) => {
    return apiRequestToken({
        endpoint: `banner/${id}`,
        method: 'PUT',
    })
};

